export default "__VITE_ASSET__BAAW0sqO__"